import api from "../../config/api";

// Serviço dedicado ao módulo STT da SHEAI
const start = (data: any) => {
  return api.post("/sheai/stt/start", data);
};

const result = (debriefing_id: any) => {
  return api.get("/sheai/stt/result/" + debriefing_id);
};

const SheAiSttService = {
  start,
  result,
};

export default SheAiSttService;
